import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import { MyValidator } from '../validators/my-validator.validator';

@Directive({
  selector: '[cslMultipleOfNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MultipleOfNumberDirective, multi: true }],
})
export class MultipleOfNumberDirective implements Validator {
  @Input() num = 0;

  validate(formControl: UntypedFormControl): ValidationErrors {
    return MyValidator.multipleOfNumber(this.num)(formControl);
  }
}
